



















































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import AnalyseSmokecrib from "./analyse-smokecrib.vue";
class PageSmokeleafRequest extends PageRequest {
  //FilterText: string;
  ftId:Number;
  wId:Number;
  fId:Number;
  keyword:string;
  Samount:0;
}
class PageCompanyRequest{
  cId:Number;
  ftId:Number;
  wId:Number;
  fId:Number;
}
@Component({
  components: {AnalyseSmokecrib},
})
export default class Smokeleafs extends AbpBase {
  pagerequest: PageSmokeleafRequest = new PageSmokeleafRequest();
  publicpagerequest: PageSmokeleafRequest = new PageSmokeleafRequest();
  pagecompanyrequest: PageCompanyRequest = new PageCompanyRequest();
  analyseModalShow: boolean = false;
  userName: string;
  cId:Number;
  selwarehouselist = [];
  selfloorlist = [];
  wflocation = "";
  get list() {
    return this.$store.state.smokeleaf.list;
  }
  get loading() {
    return this.$store.state.smokeleaf.loading;
  }
  analyse(){
    this.analyseModalShow = true;
  }
  pageChange(page: number) {
    this.$store.commit("smokeleaf/setCurrentPage", page);
    this.getPage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("smokeleaf/setPageSize", pagesize);
    this.getPage();
  }
  getsearch(){
    this.$store.state.thequipment.currentPage=1;
    this.getPage();
  }
  async getPage() {
     this.pagerequest.maxResultCount = this.pageSize;
      this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
      this.pagerequest.Samount = 0;
    //filters
    await this.$store.dispatch({
      type: "smokeleaf/getPaged",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.smokeleaf.pageSize;
  }
  get totalCount() {
    return this.$store.state.smokeleaf.totalCount;
  }
  get currentPage() {
    return this.$store.state.smokeleaf.currentPage;
  }
  getuserName() {
    //console.log(this.$store.state.session.user);
    this.userName = this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
    return this.userName;
  }
    companylist() {
    return this.$store.state.company.list;
  }
  get company(){
    return this.$store.state.company.list;
  }
  get floor() {
    return this.$store.state.floor.list;
  }
  floorlist() {
    return this.$store.state.floor.list;
  }
  get warehouse() {
    return this.$store.state.warehouse.list;
  }
  warehouselist() {
    return this.$store.state.warehouse.list;
  }
    get smokecrib() {
    return this.$store.state.smokecrib.list;
  }
  smokecriblist(){
    return this.$store.state.smokecrib.list;
  }
  get factory() {
    return this.$store.state.factory.list;
  }
  factorylist(){
    return this.$store.state.factory.list;
  }

  selCompany(value:Number){
    this.pagecompanyrequest.cId = value;
    this.getfactory();
    this.getwarehouse();
      this.getfloor();
       this.getPage();
  }

  columns = [
     {
      title: "所属公司",
      key: "cId",
      width:150,
      render: (h, params) => {
        let cId = params.row.cId;
        let clist = this.companylist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(cId==entry.id){
            cId=entry.cName;
            break;
          }
        }
        if(cId==0){
          cId="";
        }
        return h("span", cId);
      },
    },
    {
      title: "库区",
      key: "ftId",
      width:180,
      render: (h, params) => {
        let Id = params.row.ftId;
        let flist = this.factorylist();
        //console.log(clist); 
        for (let entry of flist) {
          if(Id==entry.id){
            Id=entry.fName;
            break;
          }
        }
        return h("span", Id);
      },
    },
    {
      title: "库房",
      key: "wId",
      width:180,
       render: (h, params) => {
        let wId = params.row.wId;
        let clist = this.warehouselist();
        //console.log(clist); 
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(wId==entry.id){
            wId=entry.wName;
            break;
          }
        }
        return h("span", wId);
      },
    },
    {
      title: "楼层",
      key: "fId",
      width:120,
      render: (h, params) => {
        let fId = params.row.fId;
        let clist = this.floorlist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(fId==entry.id){
            fId=entry.fName;
            break;
          }
        }
        return h("span", fId);
      },
    },
    {
      title: "垛位号",
      key: "sId",
      width:140,
       render: (h, params) => {
        let scId = params.row.sId;
        let clist = this.smokecriblist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(scId==entry.id){
               scId=entry.locationName;
            break;
          }
        }
        return h("span", scId);
      },
    },
    {
      title: "烟草产地",
      key: "yieldly",
      width:140,
    },
    {
      title: "烟叶年份",
      key: "year",
      width:120,
    },
    {
      title: "烟叶等级",
      key: "grade",
      width:120,
    },
     {
      title: "烟叶数量",
      key: "allamount",
      width:120,
    },
    {
      title: "每箱质量",
      key: "weight",
      width:120,
       render: (h, params) => {
        return h("span", params.row.weight+'/kg');
      },
    },
    {
      title: "剩余数量",
      key: "samount",
      width:120,
    },
    {
      title: "入库时间",
      key: "comeTime",
      width:120,
      render: (h, params) => {
        let ComeTime ='';
        
        ComeTime=this.GetDay(params.row.comeTime);
        return h("span", ComeTime);
      },
    },
    {
      title: "出库时间",
      key: "outTime",
      width:120,
      render: (h, params) => {
        let OutTime ='';
        
        OutTime=this.GetDay(params.row.outTime);
        return h("span", OutTime);
      },
    },
    {
      title: "操作",
      key: "Actions",
      width: 120,
      fixed:"right",
      render: (h: any, params: any) => {
        var that=this;
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  //console.log(params.row);
                  this.setNames(params.row.ftId,params.row.wId,params.row.fId,params.row.locationName);
                  this.$store.commit("smokeleaf/analyse", params.row);
                  this.analyse();
                  // that.$router.replace({path:'/monitor/analysesmokecrib'});
                  //this.$route.path("./analysesmokecrib"); ,query: params.row
                },
              },
            },
            "数据分析"
          ),
        ]);
      },
    },
  ];
   async getcompany() {
    this.publicpagerequest.maxResultCount = 99;
    this.publicpagerequest.skipCount = 0;
    //filters
    await this.$store.dispatch({
      type: "company/getAll",
      data: this.publicpagerequest,
    });
  }
  async getfactory(){
      //库区
    //filters
    await this.$store.dispatch({
      type: "factory/getPaged",
      data: this.pagecompanyrequest,
    });
  }
  GetDay(time) {
    let date = new Date(time);
    let Str = date.getFullYear() + "-" + (date.getMonth()+1) + "-" + date.getDate();
    return Str;
  }
GetBqMinutes(str){
    if(str.toString().length==1){
      return '0'+str;
    }
    return str;
  }
   setNames(paramftid,paramwid,paramfid,paramlocation){
    let ftid = paramftid;
    let wid = paramwid;
    let fid = paramfid;
    let ftlist = this.factorylist(); 
    for (let entry of ftlist) {
      if(ftid==entry.id){
        ftid=entry.fName;
        break;
      }
    }
    let wlist = this.warehouselist(); 
    for(let entry of wlist) {
      if(wid==entry.id){
        wid=entry.wName;
        break;
      }
    }
    let flist = this.floorlist();
    for(let entry of flist){
      if(fid == entry.id){
        fid = entry.fName;
        break;
      }
    }
    this.wflocation =ftid + wid + fid;
    if(ftid == 0){
      this.wflocation =wid + fid;
    }

  }
  async getwarehouse() {
    //库房
    //filters
    await this.$store.dispatch({
      type: "warehouse/getAll",
      data: this.pagecompanyrequest,
    });
  }
  async getfloor() {
    //楼层
    //filters
    await this.$store.dispatch({
      type: "floor/getAll",
      data: this.pagecompanyrequest,
    });
  }
   async getselwarehouse(){
    this.selwarehouselist = await this.$store.dispatch({
      type: "warehouse/RegetAll",
      data: this.pagecompanyrequest,
    });
  }
  async getselfloor() {
    //下拉库房加载楼层
    //filters
    this.selfloorlist = await this.$store.dispatch({
      type: "floor/RegetAll",
      data: this.pagecompanyrequest,
    });
  }
  selfactory(value:Number){
    this.pagecompanyrequest.ftId = value;
    this.pagerequest.ftId = value;
    if(value != 0){
      this.getselwarehouse();
    }
    else
    {
      this.selwarehouselist = [];
      this.selfloorlist = [];
    }
       this.$store.state.thequipment.currentPage=1;
       this.getPage();
  }
  selwarehouse(value:Number){
    this.pagecompanyrequest.wId = value;
    this.pagerequest.wId = value;
    if(value != 0 && value != undefined){
      this.getselfloor();
    }
    else{
      this.selfloorlist = [];
    }
       this.$store.state.thequipment.currentPage=1;
       this.getPage();
  }
  selfloor(value:Number){
       this.$store.state.thequipment.currentPage=1;
       this.pagerequest.fId = value;
       this.getPage();
  }
  async getsmokecrib(){
   //烟叶
    //filters
    await this.$store.dispatch({
      type: "smokecrib/getAll",
       data: this.pagecompanyrequest,
    });
 }
   async getthreshold(){
      //阈值方案
    //filters
    await this.$store.dispatch({
      type: "threshold/getAll",
      data: this.publicpagerequest,
    });
  }

  created() {
    this.getuserName();
    if (this.userName !== "admin") {
      //不符合权限的，你就没有操作这个列名！！！
      this.columns = this.columns.filter((col) => col.title !== "所属公司");
    }else{
      this.getcompany();
    }
    this.getfactory();
      this.getwarehouse();
      this.getfloor();
      this.getsmokecrib();
    this.getPage();
  }
}
